import { useList } from '@refinedev/core';
import { FormField } from '@/components/forms';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { TriggerAction } from '../../types';

interface ChannelInviteFormProps {
  action: TriggerAction;
  onChange: (patch: Partial<TriggerAction>) => void;
}

/**
 * ChannelInviteForm
 *
 * Форма действия отправки приглашения в канал
 *
 * @returns {React.ReactElement} React компонент
 */
export function ChannelInviteForm({ action, onChange }: ChannelInviteFormProps) {
  const { result: channelsResult } = useList<{ id: number; name: string; title: string }>({
    resource: 'telegram-channels',
    pagination: { currentPage: 1, pageSize: 200, mode: 'server' },
  });

  const channels = channelsResult.data ?? [];

  return (
    <FormField label="Канал" name="channelId" hint="Telegram канал для отправки приглашения">
      <Select
        value={action.channelId ? String(action.channelId) : 'none'}
        onValueChange={(v) => onChange({ channelId: v === 'none' ? undefined : Number(v) })}
      >
        <SelectTrigger>
          <SelectValue placeholder="Выберите канал" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Выберите канал</SelectItem>
          {channels.map((channel) => (
            <SelectItem key={channel.id} value={String(channel.id)}>
              {channel.title || channel.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
}
